/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from '../feed/defs.defs.js'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.getPostThreadV2'

export { $nsid }

/** (NOTE: this endpoint is under development and WILL change without notice. Don't use it until it is moved out of `unspecced` or your application WILL break) Get posts in a thread. It is based in an anchor post at any depth of the tree, and returns posts above it (recursively resolving the parent, without further branching to their replies) and below it (recursive replies, with branching to their replies). Does not require auth, but additional metadata and filtering will be applied for authed requests. */
const main = l.query(
  $nsid,
  l.params({
    anchor: l.string({ format: 'at-uri' }),
    above: l.optional(l.withDefault(l.boolean(), true)),
    below: l.optional(l.withDefault(l.integer({ minimum: 0, maximum: 20 }), 6)),
    branchingFactor: l.optional(
      l.withDefault(l.integer({ minimum: 0, maximum: 100 }), 10),
    ),
    sort: l.optional(
      l.withDefault(
        l.string<{ knownValues: ['newest', 'oldest', 'top'] }>(),
        'oldest',
      ),
    ),
  }),
  l.jsonPayload({
    thread: l.array(l.ref<ThreadItem>((() => threadItem) as any)),
    threadgate: l.optional(
      l.ref<FeedDefs.ThreadgateView>((() => FeedDefs.threadgateView) as any),
    ),
    hasOtherReplies: l.boolean(),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type ThreadItem = {
  $type?: 'app.bsky.unspecced.getPostThreadV2#threadItem'
  uri: l.AtUriString

  /**
   * The nesting level of this item in the thread. Depth 0 means the anchor item. Items above have negative depths, items below have positive depths.
   */
  depth: number
  value:
    | l.$Typed<UnspeccedDefs.ThreadItemPost>
    | l.$Typed<UnspeccedDefs.ThreadItemNoUnauthenticated>
    | l.$Typed<UnspeccedDefs.ThreadItemNotFound>
    | l.$Typed<UnspeccedDefs.ThreadItemBlocked>
    | l.Unknown$TypedObject
}

export type { ThreadItem }

const threadItem = l.typedObject<ThreadItem>(
  $nsid,
  'threadItem',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    depth: l.integer(),
    value: l.typedUnion(
      [
        l.typedRef<UnspeccedDefs.ThreadItemPost>(
          (() => UnspeccedDefs.threadItemPost) as any,
        ),
        l.typedRef<UnspeccedDefs.ThreadItemNoUnauthenticated>(
          (() => UnspeccedDefs.threadItemNoUnauthenticated) as any,
        ),
        l.typedRef<UnspeccedDefs.ThreadItemNotFound>(
          (() => UnspeccedDefs.threadItemNotFound) as any,
        ),
        l.typedRef<UnspeccedDefs.ThreadItemBlocked>(
          (() => UnspeccedDefs.threadItemBlocked) as any,
        ),
      ],
      false,
    ),
  }),
)

export { threadItem }
